// extracted by mini-css-extract-plugin
module.exports = {"form":"DownloadPDFForm_form__isH2f","button":"DownloadPDFForm_button__UUSf4"};